const dropdownToggler = document.getElementById("toggle-nav");
const dropdownNav = document.getElementById("mobile-nav");
const body = document.querySelector("body")


dropdownToggler.addEventListener('click', function () {
		this.classList.toggle('active');
		dropdownNav.classList.toggle('open');
		body.classList.toggle('height-fixed');
});


